import {ChangeDetectionStrategy, Component, OnInit, inject} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {Title} from '@angular/platform-browser';
import {Localization} from '../../../../projects/common/src/lib/interface/localization.extension';
import {AuthGuardService} from '../services/auth-guard.service';
import {COOKIE_CATALOG} from './cookie-catalog';
import {COOKIE_POLICY_VERSION, CookieConsentService} from './cookie-consent.service';
import {CookieTableComponent} from './cookie-table.component';

/**
 * /cookies: the cookie policy -- the second layer the banner links to.
 *
 * In the app rather than on the marketing site so it is drawn from the same
 * catalogue as the settings dialog and cannot drift from what the app stores.
 * Public: a visitor who has not signed in has to be able to read it.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-cookie-policy-page',
  standalone: true,
  imports: [MatIconModule, CookieTableComponent],
  templateUrl: 'cookie-policy.page.html',
  styleUrls: ['cookie-policy.page.scss'],
})
export class CookiePolicyPage extends Localization implements OnInit {
  private readonly authGuard = inject(AuthGuardService);
  private readonly title = inject(Title);
  readonly consent = inject(CookieConsentService);

  readonly categories = COOKIE_CATALOG;
  readonly version = COOKIE_POLICY_VERSION;

  ngOnInit() {
    // No auth guard on this route, and the guard is what lifts the start-up
    // splash; without this the page would sit hidden behind it.
    this.authGuard.loader.set(false);
    this.authGuard.loader$.next(false);
    this.title.setTitle(this.getString('cookie_policy'));
  }
}
